import { combineReducers } from 'redux';
import { coreUsersByIdNotificationPreferencesGetAsyncSlice } from './get';
import { coreUsersByIdNotificationPreferencesPatchAsyncSlice } from './patch';
import { coreUsersByIdNotificationsPreferencesUpdateSyncSlice } from './update';

import { combineAllWatchers, joinReducers } from '@sonar-software/xuder';

export const coreUsersByIdNotificationPreferencesReducers = combineReducers({
	get: joinReducers([
		coreUsersByIdNotificationPreferencesGetAsyncSlice.asyncReducers,
		coreUsersByIdNotificationsPreferencesUpdateSyncSlice.syncReducer
	], coreUsersByIdNotificationPreferencesGetAsyncSlice.asyncState),
	patch: coreUsersByIdNotificationPreferencesPatchAsyncSlice.asyncReducers
});

export const coreUsersByIdNotificationPreferencesWatchers = combineAllWatchers([
	coreUsersByIdNotificationPreferencesGetAsyncSlice.asyncWatchers,
	coreUsersByIdNotificationPreferencesPatchAsyncSlice.asyncWatchers
]);
